import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-venster-background',
  templateUrl: './venster-background.component.html',
  styleUrls: ['./venster-background.component.less']
})
export class VensterBackgroundComponent implements OnInit {
  @Input() color: 'yellow' | 'orange' = 'yellow';
  constructor() { }

  ngOnInit(): void {
  }

}
